var map = {
	"../../../pages/qr-code/qr-code.module": [
		"./src/app/pages/qr-code/qr-code.module.ts",
		"default~multi-order-detail-multi-order-detail-module~pages-qr-code-qr-code-module",
		"common",
		"pages-qr-code-qr-code-module"
	],
	"../../../pages/scan-qrcode/scan-qrcode.module": [
		"./src/app/pages/scan-qrcode/scan-qrcode.module.ts",
		"pages-scan-qrcode-scan-qrcode-module"
	],
	"../../../pages/verify-table-code/verify-table-code.module": [
		"./src/app/pages/verify-table-code/verify-table-code.module.ts",
		"pages-verify-table-code-verify-table-code-module"
	],
	"../DineinOrTakeawayPage/DineinOrTakeawayPage.module": [
		"./src/app/pages/DineinOrTakeawayPage/DineinOrTakeawayPage.module.ts",
		"default~DineinOrTakeawayPage-DineinOrTakeawayPage-module~brand-store-list-brand-store-list-module~ca~56a366ea",
		"common",
		"DineinOrTakeawayPage-DineinOrTakeawayPage-module"
	],
	"../brand-faq/brand-faq.module": [
		"./src/app/pages/brand-faq/brand-faq.module.ts",
		"brand-faq-brand-faq-module"
	],
	"../brand-store-list/brand-store-list.module": [
		"./src/app/pages/brand-store-list/brand-store-list.module.ts",
		"default~DineinOrTakeawayPage-DineinOrTakeawayPage-module~brand-store-list-brand-store-list-module~ca~56a366ea",
		"default~brand-store-list-brand-store-list-module~cart-multi-order-cart-multi-order-cart-module~multi~e91427d3",
		"common",
		"brand-store-list-brand-store-list-module"
	],
	"../modifier-item-select/modifier-item-select.module": [
		"./src/app/routes/item/modifier-item-select/modifier-item-select.module.ts",
		"modifier-item-select-modifier-item-select-module"
	],
	"../pages/qr-code/qr-code.module": [
		"./src/app/pages/qr-code/qr-code.module.ts",
		"default~multi-order-detail-multi-order-detail-module~pages-qr-code-qr-code-module",
		"common",
		"pages-qr-code-qr-code-module"
	],
	"../pages/side-menu-category-list/side-menu-category-list-page.module": [
		"./src/app/pages/side-menu-category-list/side-menu-category-list-page.module.ts",
		"default~DineinOrTakeawayPage-DineinOrTakeawayPage-module~brand-store-list-brand-store-list-module~ca~56a366ea",
		"default~pages-side-menu-category-list-side-menu-category-list-page-module~pop-up-set-menu-pop-up-set~d5c4b799",
		"default~pages-side-menu-category-list-side-menu-category-list-page-module~pop-up-set-menu-pop-up-set~d057974f",
		"default~pages-side-menu-category-list-side-menu-category-list-page-module~pop-up-set-menu-withImg-po~70ea4538",
		"common",
		"pages-side-menu-category-list-side-menu-category-list-page-module"
	],
	"./alipay-payment/alipay-payment.module": [
		"./src/app/routes/cart/payment/alipay-payment/alipay-payment.module.ts",
		"common",
		"alipay-payment-alipay-payment-module"
	],
	"./apple-payment/apple-payment.module": [
		"./src/app/routes/cart/payment/apple-payment/apple-payment.module.ts",
		"default~apple-payment-apple-payment-module~byod-summary-byod-summary-module~cart-multi-order-cart-mu~9559d7e3",
		"default~apple-payment-apple-payment-module~cart-multi-order-cart-multi-order-cart-module~mpgs-apple-~09171693",
		"common",
		"apple-payment-apple-payment-module"
	],
	"./byod-summary/byod-summary.module": [
		"./src/app/routes/summary/byod-summary/byod-summary.module.ts",
		"default~apple-payment-apple-payment-module~byod-summary-byod-summary-module~cart-multi-order-cart-mu~9559d7e3",
		"common",
		"byod-summary-byod-summary-module"
	],
	"./cart/multi-order-cart/multi-order-cart.module": [
		"./src/app/routes/cart/multi-order-cart/multi-order-cart.module.ts",
		"default~apple-payment-apple-payment-module~byod-summary-byod-summary-module~cart-multi-order-cart-mu~9559d7e3",
		"default~apple-payment-apple-payment-module~cart-multi-order-cart-multi-order-cart-module~mpgs-apple-~09171693",
		"default~DineinOrTakeawayPage-DineinOrTakeawayPage-module~brand-store-list-brand-store-list-module~ca~56a366ea",
		"default~brand-store-list-brand-store-list-module~cart-multi-order-cart-multi-order-cart-module~multi~e91427d3",
		"default~cart-multi-order-cart-multi-order-cart-module~oepay-payment-oepay-payment-module",
		"common",
		"cart-multi-order-cart-multi-order-cart-module"
	],
	"./credit-card-payment/credit-card-payment.module": [
		"./src/app/routes/cart/payment/credit-card-payment/credit-card-payment.module.ts",
		"common",
		"credit-card-payment-credit-card-payment-module"
	],
	"./eft-payment/eft-payment.module": [
		"./src/app/routes/cart/payment/eft-payment/eft-payment.module.ts",
		"common",
		"eft-payment-eft-payment-module"
	],
	"./modifier-item-select/modifier-item-select.module": [
		"./src/app/routes/item/modifier-item-select/modifier-item-select.module.ts",
		"modifier-item-select-modifier-item-select-module"
	],
	"./mpgs-apple-pay-payment/mpgs-apple-pay-payment.module": [
		"./src/app/routes/cart/payment/mpgs-apple-pay-payment/mpgs-apple-pay-payment.module.ts",
		"default~apple-payment-apple-payment-module~byod-summary-byod-summary-module~cart-multi-order-cart-mu~9559d7e3",
		"default~apple-payment-apple-payment-module~cart-multi-order-cart-multi-order-cart-module~mpgs-apple-~09171693",
		"default~mpgs-apple-pay-payment-mpgs-apple-pay-payment-module~summary-list-summary-list-module",
		"common",
		"mpgs-apple-pay-payment-mpgs-apple-pay-payment-module"
	],
	"./mpgs-credit-card-payment/mpgs-credit-card-payment.module": [
		"./src/app/routes/cart/payment/mpgs-credit-card-payment/mpgs-credit-card-payment.module.ts",
		"common",
		"mpgs-credit-card-payment-mpgs-credit-card-payment-module"
	],
	"./mpgs-google-pay-payment/mpgs-google-pay-payment.module": [
		"./src/app/routes/cart/payment/mpgs-google-pay-payment/mpgs-google-pay-payment.module.ts",
		"default~apple-payment-apple-payment-module~byod-summary-byod-summary-module~cart-multi-order-cart-mu~9559d7e3",
		"default~apple-payment-apple-payment-module~cart-multi-order-cart-multi-order-cart-module~mpgs-apple-~09171693",
		"common",
		"mpgs-google-pay-payment-mpgs-google-pay-payment-module"
	],
	"./mpgs-host-session/mpgs-host-session.module": [
		"./src/app/routes/cart/payment/mpgs-host-session/mpgs-host-session.module.ts",
		"common",
		"mpgs-host-session-mpgs-host-session-module"
	],
	"./multi-order-detail/multi-order-detail.module": [
		"./src/app/routes/summary/multi-order-detail/multi-order-detail.module.ts",
		"default~multi-order-detail-multi-order-detail-module~pages-qr-code-qr-code-module",
		"common",
		"multi-order-detail-multi-order-detail-module"
	],
	"./multi-order-history/multi-order-history.module": [
		"./src/app/routes/summary/multi-order-history/multi-order-history.module.ts",
		"default~apple-payment-apple-payment-module~cart-multi-order-cart-multi-order-cart-module~mpgs-apple-~09171693",
		"common",
		"multi-order-history-multi-order-history-module"
	],
	"./multi-step-combo/multi-step-combo.module": [
		"./src/app/routes/item/multi-step-combo/multi-step-combo.module.ts",
		"default~DineinOrTakeawayPage-DineinOrTakeawayPage-module~brand-store-list-brand-store-list-module~ca~56a366ea",
		"default~brand-store-list-brand-store-list-module~cart-multi-order-cart-multi-order-cart-module~multi~e91427d3",
		"default~multi-step-combo-multi-step-combo-module~set-sub-items-set-sub-items-module",
		"common",
		"multi-step-combo-multi-step-combo-module"
	],
	"./oepay-payment/oepay-payment.module": [
		"./src/app/routes/cart/payment/oepay-payment/oepay-payment.module.ts",
		"default~apple-payment-apple-payment-module~byod-summary-byod-summary-module~cart-multi-order-cart-mu~9559d7e3",
		"default~apple-payment-apple-payment-module~cart-multi-order-cart-multi-order-cart-module~mpgs-apple-~09171693",
		"default~cart-multi-order-cart-multi-order-cart-module~oepay-payment-oepay-payment-module",
		"common",
		"oepay-payment-oepay-payment-module"
	],
	"./openrice-payment/openrice-payment.module": [
		"./src/app/routes/cart/payment/openrice-payment/openrice-payment.module.ts",
		"common",
		"openrice-payment-openrice-payment-module"
	],
	"./order-detail/order-detail.module": [
		"./src/app/routes/summary/order-detail/order-detail.module.ts",
		"order-detail-order-detail-module"
	],
	"./order-status/order-status.module": [
		"./src/app/routes/summary/order-status/order-status.module.ts",
		"common",
		"order-status-order-status-module"
	],
	"./pages/byod-brand-splash/byod-brand-splash.module": [
		"./src/app/pages/byod-brand-splash/byod-brand-splash.module.ts",
		"default~DineinOrTakeawayPage-DineinOrTakeawayPage-module~brand-store-list-brand-store-list-module~ca~56a366ea",
		"common",
		"pages-byod-brand-splash-byod-brand-splash-module"
	],
	"./pages/test/test.module": [
		"./src/app/pages/test/test.module.ts",
		"common",
		"pages-test-test-module"
	],
	"./pop-up-set-menu-withImg/pop-up-set-menu-withImg-page.module": [
		"./src/app/routes/item/pop-up-set-menu-withImg/pop-up-set-menu-withImg-page.module.ts",
		"default~pages-side-menu-category-list-side-menu-category-list-page-module~pop-up-set-menu-pop-up-set~d5c4b799",
		"default~pages-side-menu-category-list-side-menu-category-list-page-module~pop-up-set-menu-withImg-po~70ea4538",
		"common",
		"pop-up-set-menu-withImg-pop-up-set-menu-withImg-page-module"
	],
	"./pop-up-set-menu/pop-up-set-menu.module": [
		"./src/app/routes/item/pop-up-set-menu/pop-up-set-menu.module.ts",
		"default~pages-side-menu-category-list-side-menu-category-list-page-module~pop-up-set-menu-pop-up-set~d5c4b799",
		"default~pages-side-menu-category-list-side-menu-category-list-page-module~pop-up-set-menu-pop-up-set~d057974f",
		"common",
		"pop-up-set-menu-pop-up-set-menu-module"
	],
	"./routes/summary/order-status/order-status.module": [
		"./src/app/routes/summary/order-status/order-status.module.ts",
		"common",
		"order-status-order-status-module"
	],
	"./routes/summary/summary-list/summary-list.module": [
		"./src/app/routes/summary/summary-list/summary-list.module.ts",
		"default~mpgs-apple-pay-payment-mpgs-apple-pay-payment-module~summary-list-summary-list-module",
		"common",
		"summary-list-summary-list-module"
	],
	"./saved-order-list/saved-order-list.module": [
		"./src/app/routes/summary/saved-order-list/saved-order-list.module.ts",
		"saved-order-list-saved-order-list-module"
	],
	"./set-sub-items/set-sub-items.module": [
		"./src/app/routes/item/set-sub-items/set-sub-items.module.ts",
		"default~DineinOrTakeawayPage-DineinOrTakeawayPage-module~brand-store-list-brand-store-list-module~ca~56a366ea",
		"default~brand-store-list-brand-store-list-module~cart-multi-order-cart-multi-order-cart-module~multi~e91427d3",
		"default~pages-side-menu-category-list-side-menu-category-list-page-module~pop-up-set-menu-pop-up-set~d5c4b799",
		"default~multi-step-combo-multi-step-combo-module~set-sub-items-set-sub-items-module",
		"common",
		"set-sub-items-set-sub-items-module"
	],
	"./stripe-google-pay-payment/stripe-google-pay-payment.module": [
		"./src/app/routes/cart/payment/stripe-google-pay-payment/stripe-google-pay-payment.module.ts",
		"default~apple-payment-apple-payment-module~byod-summary-byod-summary-module~cart-multi-order-cart-mu~9559d7e3",
		"default~apple-payment-apple-payment-module~cart-multi-order-cart-multi-order-cart-module~mpgs-apple-~09171693",
		"common",
		"stripe-google-pay-payment-stripe-google-pay-payment-module"
	],
	"./stripe/stripe.module": [
		"./src/app/routes/cart/payment/stripe/stripe.module.ts",
		"common",
		"stripe-stripe-module"
	],
	"./summary-list/summary-list.module": [
		"./src/app/routes/summary/summary-list/summary-list.module.ts",
		"default~mpgs-apple-pay-payment-mpgs-apple-pay-payment-module~summary-list-summary-list-module",
		"common",
		"summary-list-summary-list-module"
	],
	"./valoot-wechat-pay-payment/valoot-wechat-pay-payment.module": [
		"./src/app/routes/cart/payment/valoot-wechat-pay-payment/valoot-wechat-pay-payment.module.ts",
		"common",
		"valoot-wechat-pay-payment-valoot-wechat-pay-payment-module"
	],
	"./wechat-open-payment/wechat-open-payment.module": [
		"./src/app/routes/cart/payment/wechat-open-payment/wechat-open-payment.module.ts",
		"common",
		"wechat-open-payment-wechat-open-payment-module"
	],
	"./wechat-pay-payment/wechat-pay-payment.module": [
		"./src/app/routes/cart/payment/wechat-pay-payment/wechat-pay-payment.module.ts",
		"common",
		"wechat-pay-payment-wechat-pay-payment-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;